<div class="container">
    <img src="../../../../assets/images/logos/logo_ezycharge_main.png" alt="EzyCharge Logo" class="logo" />
    <img src="../../../../assets/images/web-login.png" alt="Login Illustration" class="illustration" />

    <div class="title-wrapper">
        <h2 class="login-title">Login</h2>
        <p class="login-subtitle">Let’s login to explore more</p>
    </div>

    <label for="phone" class="phone-label">{{ otpSent ? 'OTP' : 'Phone Number' }}</label>

    <div class="input-group">
        <ng-container *ngIf="!otpSent; else otpBlock">
            <select class="country-code" [(ngModel)]="countryCode">
                <option value="+91">+91</option>
                <option value="+92">+92</option>
                <option value="+93">+93</option>
                <option value="+94">+94</option>
            </select>
            <input type="tel" id="phone" [(ngModel)]="phoneNumber" maxlength="10" pattern="[0-9]*"
                (input)="validatePhone()" placeholder="Enter Mobile Number" class="phone-input" />
        </ng-container>
    
        <ng-template #otpBlock>
            <input type="tel" id="otp" [(ngModel)]="otp" maxlength="6" pattern="[0-9]*"
                (input)="validateOtp()" placeholder="Enter OTP" class="otp-input" />
        </ng-template>
    </div>
    
    <p class="error-message" *ngIf="phoneError">Please enter a valid 10-digit phone number.</p>
    <p class="error-message" *ngIf="otpError">Please enter a valid 6-digit OTP.</p>
    
    <button type="button" class="login-button" (click)="getOtp()" *ngIf="!otpSent">Log in</button>
    <button type="button" class="login-button" (click)="verifyOtp()" *ngIf="otpSent">Verify OTP</button>

    <p class="agreement">
        By tapping Login, you agree to our
        <a href="https://ezy-charge.com/about-us.php" target="_blank">About Us</a>,
        <a href="https://ezy-charge.com/contact.php" target="_blank">Contact Us</a>,
        <a href="https://ezy-charge.com/privacy-policy.php" target="_blank">Privacy & Policy</a>,
        <a href="https://ezy-charge.com/refund-cancellation-policy.php" target="_blank">Refund & Cancellation Policy</a>.
    </p>
</div>